// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "close__text-3mGTW";
var _3 = "header-Jef1w";
var _4 = "header__text-1hHfP";
export { _1 as "__esModule", _2 as "close__text", _3 as "header", _4 as "header__text" }
export default { "__esModule": _1, "close__text": _2, "header": _3, "header__text": _4 }
